import { Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InlineLifeDescriptionSkeleton = styled(Skeleton)({
    display: "inline-block",
    width: 50,
});
